import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "tw-rounded-xl tw-border tw-border-rose-200/70 tw-bg-rose-50 tw-px-4 tw-py-3 tw-text-sm tw-text-rose-900"
}
const _hoisted_3 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-justify-end tw-gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isOpen) = $event)),
    modalId: "create-driver-modal",
    maxWidth: "2xl",
    onClose: _ctx.onClose
  }, {
    title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
      _createTextVNode("New Driver", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loadFormError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.loadFormError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "createDriver_name",
              class: "tw-text-sm tw-font-medium tw-text-slate-700"
            }, "Driver Name (*required)", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              type: "text",
              id: "createDriver_name",
              class: "tw-mt-1 tw-h-10 tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-text-slate-900"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "createDriver_phone",
              class: "tw-text-sm tw-font-medium tw-text-slate-700"
            }, "Driver Phone # (*required)", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
              id: "createDriver_phone",
              type: "text",
              class: "tw-mt-1 tw-h-10 tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-text-slate-900"
            }, null, 512), [
              [_vModelText, _ctx.phone]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "createDriver_isOwnerOperator",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event)),
            class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
          }, null, 512), [
            [_vModelCheckbox, _ctx.checked]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "createDriver_isOwnerOperator",
            class: "tw-text-sm tw-text-slate-700"
          }, "Is Company Driver?", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createNewDriver && _ctx.createNewDriver(...args))),
            disabled: !(_ctx.name && _ctx.phone) || _ctx.loading
          }, " Add New Driver ", 8, _hoisted_6)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Saving..."))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
}